import { useEffect } from 'react';

import { useUser } from '@adsk/alloy-provider';

import {
  setOverrideToErrorContext,
  setUserToErrorContext,
} from '../utils/monitoring';

const ACCErrorContextSetter = () => {
  const { user } = useUser();

  useEffect(() => {
    if (user?.id) {
      setUserToErrorContext({
        id: user.id,
        email: user.email,
        analyticsId: user.analyticsId,
      });
    }
  }, [user?.id, user?.email, user?.analyticsId]);

  useEffect(() => {
    setOverrideToErrorContext();
  }, []);

  return null;
};

export default ACCErrorContextSetter;
